const POWERED_OFF_REASON_KEYS = new Map<string, string>([
  ['battery', 'walt.powered-off-reasons.battery'],
  ['user', 'walt.powered-off-reasons.user'],
  ['device-management', 'walt.powered-off-reasons.device-management'],
  ['too-hot', 'walt.powered-off-reasons.too-hot'],
  ['too-cold', 'walt.powered-off-reasons.too-cold'],
]);

/** Label key for why a walt powered off; a missing or unrecognised reason is Unknown. */
export const poweredOffReasonKey = (reason?: string | null): string =>
  (reason && POWERED_OFF_REASON_KEYS.get(reason)) || 'generics.unknown';
